<style lang="scss" scoped>
</style>
<template>
    <div>
        <jijiu-page-title title="医生管理">
            <div class="ml10">
                <el-button size="mini" type="primary" @click="add">添加医生</el-button>
            </div>
        </jijiu-page-title>
        <div class="mt10">
            <el-table
                :data="list"
                size="mini"
                border
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="是否启用"
                    width="180">
                    <template slot-scope="{row}">
                        <span :class="[row.enabled_class]">{{row.enabled_text}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hosName"
                    label="所属医院"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="deptName"
                    label="所属科室"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="docName"
                    label="医生姓名"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="docTitle"
                    label="职称"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="{row}">
                        <el-button type="text" size="mini" @click="startOrstop(row)">{{row.opera_btn}}</el-button>
                        <el-button type="text" size="mini" @click="modify(row)">修改</el-button>
                        <!--<el-button type="text" @click="detail(row)">详情</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="mt10">
            <el-pagination
                background
                @current-change="getList"
                :page-size="page.pageSize"
                layout="total, prev, pager, next"
                :total="page.total">
            </el-pagination>
        </div>
        <add-doc-dialog ref="addDoc" @ok="getList"></add-doc-dialog>
    </div>
</template>
<script>
  import JijiuPageTitle from "../components/jijiu-page-title";
  import {staffService} from "../service/staff";
  import {USER_TYPE} from "../../../common/lib/config";
  import AddDocDialog from "../components/add-doc-dialog";

  export default {
    name: 'jijiu-doc',
    components: {AddDocDialog, JijiuPageTitle},
    data() {
      return {
        list: [],
        page: {
          pageSize: 10,
          pageNum: 1
        }
      }
    },
    created() {
      this.getList(1);
    },
    methods: {
      add() {
        this.$refs.addDoc.show(USER_TYPE.DOC.id);
      },
      modify(data) {
        this.$refs.addDoc.show(USER_TYPE.DOC.id, data.id);
      },
      async detail(data) {
        await staffService.detailDoc(data.id);
      },
      startOrstop(data) {
        this.$confirm(`是否${data.opera_btn} ${data.docName}？`)
          .then(async () => {
            if (await staffService.enabledDoc(data.id, !data.enabled)) {
              this.$message.success('操作成功');
              this.getList(this.page.pageNum);
            }
          });
      },
      async getList(pageNum) {
        const {list, page} = await staffService.listsDoc({
          userType: USER_TYPE.DOC.id,
          pageNo: pageNum
        });
        this.list = list;
        this.page = page;
      }
    },
  }
</script>
